<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3265_1311)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3265_1311)" />
    </g>
    <path
      d="M20.4548 12.3333H13.4548C11.982 12.3333 10.7881 13.5272 10.7881 15V21C10.7881 22.4727 11.982 23.6666 13.4548 23.6666H20.4548C21.9275 23.6666 23.1214 22.4727 23.1214 21V15C23.1214 13.5272 21.9275 12.3333 20.4548 12.3333Z"
      stroke="white" />
    <path
      d="M10.8193 15.06L15.6227 17.8133C16.0251 18.0471 16.4822 18.1703 16.9477 18.1703C17.4131 18.1703 17.8702 18.0471 18.2727 17.8133L23.0893 15.06"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <defs>
      <filter id="filter0_d_3265_1311"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.607843 0 0 0 0 0.756863 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3265_1311" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3265_1311" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3265_1311"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#E8EC1A" />
        <stop offset="1" stop-color="#7DA311" />
      </linearGradient>
    </defs>
  </svg>
</template>
